<ion-app>
  <ion-router-outlet id="main-content" [animated]="false"></ion-router-outlet>
  <ion-modal class="modal-generic" [isOpen]="isErrorModalOpen" backdropDismiss="false">
    <ng-template>
      <efp-request-sync-error-message-popup
        (dismissed)="closeErrorModal()"></efp-request-sync-error-message-popup>
    </ng-template>
  </ion-modal>
</ion-app>
